/* eslint-disable */

// Node Module Imports
import { Link } from 'gatsby'
import React from 'react'
import styled from 'styled-components'

// Component Imports
import Layout from '../components/core/layout'
import SEO from '../components/core/seo'
import UtilityHeader from '../components/headers/UtilityHeader'

const CaresActPage = ({ className }) => {
  return (
    <Layout>
      <SEO
        title="CARES Act Disclosures"
        description="Learn more about UMA's office CARES Act Disclosures by visiting this page."
      />

      <div className={className}>
        <UtilityHeader>
          <h1>CARES Act Disclosures</h1>
        </UtilityHeader>

        <div className="container container--sm py-9">
          <p>
            Ultimate Medical Academy's official disclosures regarding the Coronavirus Aid, Relief, and Economic Security
            Act (CARES Act) of 2020:
          </p>
          <ul>
            <li>
              <a href="/pdfs/cares/061220-student-portion-report.pdf" rel="noopener noreferrer" target="_blank">
                CARES Act Student Portion Report &ndash; 6/12/2020 (.pdf)
              </a>
            </li>
            <li>
              <a href="/pdfs/cares/080420-student-portion-report.pdf" rel="noopener noreferrer" target="_blank">
                CARES Act Student Portion Report &ndash; 8/4/2020 (.pdf)
              </a>
            </li>
            <li>
              <a href="/pdfs/cares/103020-student-portion-report.pdf" rel="noopener noreferrer" target="_blank">
                CARES Act Student Portion Report &ndash; 10/30/2020 (Final Report) (.pdf)
              </a>
            </li>
            <li>
              <a href="/pdfs/cares/063021-student-portion-report.pdf" rel="noopener noreferrer" target="_blank">
                CARES Act Student Portion Report &ndash; 6/30/2021 (.pdf)
              </a>
            </li>
            <li>
              <a href="/pdfs/cares/070921-student-portion-report.pdf" rel="noopener noreferrer" target="_blank">
                CARES Act Student Portion Report &ndash; 7/9/2021 (.pdf)
              </a>
            </li>
            <li>
              <a href="/pdfs/cares/09302021-student-portion-report.pdf" rel="noopener noreferrer" target="_blank">
                CARES Act Student Portion Report &ndash; 9/30/2021 (.pdf)
              </a>
            </li>
            <li>
              <a href="/pdfs/cares/010622-student-portion-report.pdf" rel="noopener noreferrer" target="_blank">
                CARES Act Student Portion Report &ndash; 1/6/2022 (.pdf)
              </a>
            </li>
            <li>
              <a href="/pdfs/cares/041022-student-portion-report.pdf" rel="noopener noreferrer" target="_blank">
                CARES Act Student Portion Report &ndash; 4/10/2022 (.pdf)
              </a>
            </li>
            <li>
              <a
                href="/pdfs/cares/103020-quarterly-budget-for-institutional-portion.pdf"
                rel="noopener noreferrer"
                target="_blank">
                CARES Act Quarterly Institutional Report &ndash; 10/30/2020 (.pdf)
              </a>
            </li>
            <li>
              <a
                href="/pdfs/cares/010821-quarterly-budget-for-institutional-portion.pdf"
                rel="noopener noreferrer"
                target="_blank">
                CARES Act Quarterly Institutional Report &ndash; 1/8/2021 (.pdf)
              </a>
            </li>
            <li>
              <a
                href="/pdfs/cares/040721-quarterly-budget-for-institutional-portion.pdf"
                rel="noopener noreferrer"
                target="_blank">
                CARES Act Quarterly Institutional Report &ndash; 4/7/2021 (Final Report) (.pdf)
              </a>
            </li>
            <li>
              <a
                href="/pdfs/cares/063021-quarterly-budget-for-institutional-portion.pdf"
                rel="noopener noreferrer"
                target="_blank">
                CARES Act Quarterly Institutional Report &ndash; 6/30/2021 (.pdf)
              </a>
            </li>
            <li>
              <a
                href="/pdfs/cares/070921-quarterly-budget-for-institutional-portion.pdf"
                rel="noopener noreferrer"
                target="_blank">
                CARES Act Quarterly Institutional Report &ndash; 7/9/2021 (.pdf)
              </a>
            </li>
            <li>
              <a href="/pdfs/cares/03549300_HEERF_Q32021_101021.pdf" rel="noopener noreferrer" target="_blank">
                CARES Act Quarterly Institutional Report &ndash; 10/8/2021 (.pdf)
              </a>
            </li>
            <li>
              <a
                href="/pdfs/cares/010622-quarterly-budget-for-institutional-portion.pdf"
                rel="noopener noreferrer"
                target="_blank">
                CARES Act Quarterly Institutional Report &ndash; 1/6/2022 (.pdf)
              </a>
            </li>
            <li>
              <a
                href="/pdfs/cares/040722-quarterly-budget-for-institutional-portion.pdf"
                rel="noopener noreferrer"
                target="_blank">
                CARES Act Quarterly Institutional Report &ndash; 4/7/2022 (.pdf)
              </a>
            </li>
            <li>
              <a
                href="/pdfs/cares/070522-quarterly-budget-for-institutional-portion.pdf"
                rel="noopener noreferrer"
                target="_blank">
                CARES Act Quarterly Reporting for HEERF I, II & III funds &ndash; 7/5/2022 (.pdf)
              </a>
            </li>
            <li>
              <a href="/pdfs/cares/100322-quarterly-budget.pdf" rel="noopener noreferrer" target="_blank">
                CARES Act Quarterly Reporting for HEERF I, II & III funds &ndash; 10/3/2022 (.pdf)
              </a>
            </li>
            <li>
              <a href="/pdfs/cares/010523-quarterly-budget.pdf" rel="noopener noreferrer" target="_blank">
                CARES Act 2022 Quarter 4 Reporting for HEERF I, II & III funds &ndash; 1/5/2023 (.pdf)
              </a>
            </li>
            <li>
              <a href="/pdfs/cares/030323-quarterly-budget.pdf" rel="noopener noreferrer" target="_blank">
                Corrected CARES Act 2022 Quarter 2 Reporting for HEERF I, II & III funds (.pdf)
              </a>
            </li>
          </ul>
        </div>
      </div>
    </Layout>
  )
}

export default styled(CaresActPage)``
